import { getUser } from "../../auth";
import DeleteSaleUI from "../components/DeleteSaleUI";

const URL = process.env.REACT_APP_API_URL;

export default function DeleteSale({ selectedSales, onDelete }) {
  const handleDelete = () => {
    const user = getUser();
    Promise.all(
      selectedSales.map((saleId) =>
        fetch(`${URL}/api/sales/${saleId}`, {
          method: "DELETE",
          headers: {
            "X-Empresa-Id": user?.empresa_id,
          },
        })
      )
    )
      .then(() => {
        onDelete();
      })
      .catch((error) => console.error("Error deleting sales:", error));
  };

  return (
    <DeleteSaleUI
      selectedSales={selectedSales}
      onDelete={handleDelete}
    />
  );
}
